module.exports = __webpack_public_path__ + "img/portfolio-4.4c9a86bb.jpg";